// Typelizer digest 24a46d7ded2b415cdee0c2726c1cf19c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/bank_accounts/:bank_account_id/statement */
  show: (
    params: { bankAccountId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/bank_accounts/:bank_account_id/statement', params, options),
    method: 'get',
  }),
}
